export default __webpack_public_path__ + "static/media/HelpCenter_Image.34cc23f1.png";